import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";

var get = "/summary/payment";
export const actGetDataPaymentSummary = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_SUMMARY_PAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_SUMMARY_PAYMENT",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_SUMMARY_PAYMENT", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SUMMARY_PAYMENT",
          message: "Network error..",
        });
      });
  };
};
